module.exports = __webpack_public_path__ + "static/media/avoid.a5d8a6a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/portfolio/thumbnails/avoid.png
// module id = 256
// module chunks = 0